export default __webpack_public_path__ + "static/media/ShopperrFaqs.67ff1974.pdf";